import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import i18n from '../i18n';
import { compose } from 'redux';
import { connect } from 'react-redux';
import CustomersActions from '../redux/CustomersRedux';
import { withStyles } from '@material-ui/styles';
import withWidth from '@material-ui/core/withWidth';
import clsx from 'clsx';
import { Colors, StyledComponents, Metrics } from '../themes';
import cloneDeep from 'lodash/cloneDeep';
import Header from '../components/header/Header';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Table from '../components/common/Table';
import CustomerDetails from '../components/customersElements/CustomersDetails';
import AlertDialog from '../components/common/AlertDialog';
import SnackbarNotification from '../components/common/SnackbarNotification';

const { MainContentContainer } = StyledComponents;

const styles = (theme) => ({
  gridContainer: {
    [theme.breakpoints.up('xl')]: {
      maxWidth: Metrics.contentGridMaxWidthXl.general,
    },
  },
  paper: {
    textAlign: 'center',
    background: Colors.hoverGrey,
    color: Colors.white,
  },
  listWidget: {},
  detailsWidget: {
    maxWidth: 975,
  },
});

class Customers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // customers page params
      customerItemsPerPage: 10,
      customerPageNumber: 0,
      customerSearchValue: null,
      // snackbar
      isSnackbarNotificationOpen: false,
      snackbarVariant: 'warning',
      snackbarMessage: '',
      // alert confirm dialog
      isAlertDialogOpen: false,
      alertTitle: '',
      alertContentText: '',
      alertConfirmAction: null,
      isSaveAlert: false,
      // customer details
      isNewCustomer: false,
      customerId: null,
      addressId: null,
      firstName: '',
      lastName: '',
      street1: '',
      street1no: '',
      zip: '',
      city: '',
      customerNumber: '',
      customerSettings: [],
      hideDetails: true,
    };
  }

  componentDidMount() {
    if (this.props.distributorId) {
      this.sendGetCustomersForAdminRequest();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.distributorId !== this.props.distributorId) {
      if (this.props.distributorId) {
        this.sendGetCustomersForAdminRequest();
      }
    }
    if (prevProps.customersIsLoading && !this.props.customersIsLoading) {
      if (this.props.successMessage) {
        this.setState({
          isSnackbarNotificationOpen: true,
          snackbarVariant: 'success',
          snackbarMessage: this.props.successMessage,
        });
      }
      if (this.props.errorMessage) {
        this.setState({
          isSnackbarNotificationOpen: true,
          snackbarVariant: 'error',
          snackbarMessage: this.props.errorMessage,
        });
      }
      if (prevProps.createdId !== this.props.createdId) {
        this.setState({
          customerId: this.props.createdId,
          addressId: this.props.createdAddressId,
          isNewCustomer: false,
        });
      }
    }
  }
  sendGetCustomersForAdminRequest() {
    const pageParams = {
      items: this.state.customerItemsPerPage,
      page: this.state.customerPageNumber,
      value: this.state.customerSearchValue,
    };
    this.props.getCustomersForAdmin(this.props.distributorId, pageParams);
  }

  //common methods

  handleChangeFormValues = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleAddCustomer = () => {
    this.resetCustomerFormFields();
    this.setState({ hideDetails: false, customerSearchValue: null, isNewCustomer: true });
  };

  selectCustomer = (customer) => {
    this.resetCustomerFormFields();
    let customerId = customer.customerId ? customer.customerId : null,
      addressId = customer.address && customer.address.addressId ? customer.address.addressId : '',
      firstName = customer.address && customer.address.firstName ? customer.address.firstName : '',
      lastName = customer.address && customer.address.lastName ? customer.address.lastName : '',
      street1 = customer.address && customer.address.street1 ? customer.address.street1 : '',
      street1no = customer.address && customer.address.street1no ? customer.address.street1no : '',
      zip = customer.address && customer.address.zip ? customer.address.zip : '',
      city = customer.address && customer.address.city ? customer.address.city : '',
      customerNumber = customer.customerNumber ? customer.customerNumber : '',
      customerSettings = customer.customerSettings;

    this.setState({
      hideDetails: false,
      isNewCustomer: false,
      customerId,
      addressId,
      firstName,
      lastName,
      street1,
      street1no,
      zip,
      city,
      customerNumber,
      customerSettings,
    });
  };

  changeCustomerItemsPerPage = (customerItemsPerPage) => {
    this.setState({ customerItemsPerPage, customerPageNumber: 0 }, () => this.sendGetCustomersForAdminRequest());
  };

  changeCustomerPage = (customerPageNumber) => {
    this.setState({ customerPageNumber }, () => this.sendGetCustomersForAdminRequest());
  };

  handleSearchCustomer = (customerSearchValue) => {
    this.setState({ customerSearchValue, customerPageNumber: 0 }, () => this.sendGetCustomersForAdminRequest());
    this.resetCustomerFormFields();
  };

  handleSortCustomer = (customerSortBy, customerSortDirection) => {
    this.setState({ customerSortDirection, customerPageNumber: 0 }, () => this.sendGetCustomersForAdminRequest());
    this.resetCustomerFormFields();
  };

  handleSearchCustomerKeyPress = (event, value) => {
    if (event.key === 'Enter') {
      this.handleSearchCustomer(value);
    }
  };

  resetCustomerFormFields = () => {
    this.setState({
      addressId: null,
      firstName: '',
      lastName: '',
      street1: '',
      street1no: '',
      zip: '',
      city: '',
      customerNumber: '',
    });
  };

  openDeleteCustomerAlert = () => {
    const customerName = this.state.lastName ? `${this.state.firstName} ${this.state.lastName}` : this.state.firstName;
    this.setState({
      isAlertDialogOpen: true,
      isSaveAlert: false,
      alertTitle: i18n.t('alert.deleteCustomerTitle'),
      alertContentText: i18n.t('customerManager_confirmDelete', {
        customerName,
      }),
      alertConfirmAction: this.deleteCustomer,
    });
  };

  deleteCustomer = () => {
    const pageParams = {
      items: this.state.customerItemsPerPage,
      page: this.state.customerPageNumber,
      value: this.state.customerSearchValue,
    };
    this.props.deleteCustomer(this.state.customerId, this.props.distributorId, pageParams);
    this.resetCustomerFormFields();
    this.setState({ isAlertDialogOpen: false, hideDetails: true });
  };

  handleSaveCustomer = () => {
    const {
      customerId,
      addressId,
      firstName,
      lastName,
      street1,
      street1no,
      zip,
      city,
      customerNumber,
      customerSettings,
    } = this.state;
    const customerInfos = {
      address: { firstName, lastName, street1, street1no, zip, city },
      distributorId: this.props.distributorId,
      customerNumber,
      customerSettings,
      status: 1,
    };
    const editCustomerInfos = { ...customerInfos, customerId, address: { ...customerInfos.address, addressId } };
    const pageParams = {
      items: this.state.customerItemsPerPage,
      page: this.state.customerPageNumber,
      value: this.state.customerSearchValue,
    };
    this.state.isNewCustomer
      ? this.props.createCustomer(customerInfos, this.props.distributorId, pageParams)
      : this.props.editCustomer(editCustomerInfos, this.props.distributorId, pageParams);
  };

  handleCustomerDetailsFormKeyPress = (event) => {
    // disabled, as it already works without
    // if (event.key === 'Enter') {
    //   if (!this.state.customerSearchValue) {
    //     return this.handleSaveCustomer();
    //   }
    // }
  };

  render() {
    const { t, classes, width } = this.props;
    const isLarge = width === 'lg' || width === 'xl';
    const customersData = cloneDeep(this.props.customers); //this is necessary for table to work
    const flattenedcustomersData = customersData
      ? customersData.map((customer) => ({
          ...customer,
          name: `${customer.address.firstName} ${customer.address.lastName}`,
        }))
      : null;
    return (
      <MainContentContainer className={classes.MainContentContainer}>
        <AlertDialog
          open={this.state.isAlertDialogOpen}
          handleClose={() => this.setState({ isAlertDialogOpen: false })}
          title={this.state.alertTitle}
          contentText={this.state.alertContentText}
          cancelButtonText={t(this.state.isSaveAlert ? 'Global_discard' : 'Global_cancel')}
          confirmButtonText={t(this.state.isSaveAlert ? 'Global_save' : 'Global_delete')}
          onConfirm={this.state.alertConfirmAction}
          {...(this.state.isSaveAlert && {
            leftButtonRed: true,
            rightButtonBlue: true,
            leftButtonAction: this.discardControllerChanges,
          })}
        />
        <SnackbarNotification
          variant={this.state.snackbarVariant}
          open={this.state.isSnackbarNotificationOpen}
          message={this.state.snackbarMessage}
          close={() => this.setState({ isSnackbarNotificationOpen: false })}
        />

        <Header />
        <Grid container className={classes.gridContainer} spacing={isLarge ? 6 : 5}>
          <Grid item xs={12} md={6} xl={5}>
            <Paper className={clsx(classes.paper, classes.listWidget)}>
              <Table
                data={flattenedcustomersData}
                noDataText={t('customer.noCustomer')}
                handleClick={(value) => this.selectCustomer(value)}
                columns={[{ title: t('common.name'), field: 'name', id: 'name' }]}
                activeRowValue={this.state.customerId}
                activeRowField={'customerId'}
                handleSearch={this.handleSearchCustomer}
                sortBy={'name'}
                sortDirection={this.state.customerSortDirection}
                handleSort={this.handleSortCustomer}
                searchPlaceholder={t('customer.searchCustomer')}
                itemsPerPage={this.state.customerItemsPerPage}
                changeItemsPerPage={this.changeCustomerItemsPerPage}
                totalElements={this.props.customerTotalElements}
                page={this.state.customerPageNumber}
                changePage={this.changeCustomerPage}
                onKeyPress={this.handleSearchCustomerKeyPress}
                //rows per page select props
                selectData={[5, 10, 20]}
                selectLabel={t('table.showPerPage')}
                selectValue={this.state.customerItemsPerPage}
                onSelect={this.changeCustomerItemsPerPage}
                selectWidth={90}
              />
            </Paper>
          </Grid>
          <Grid item xs={12} md={6} xl={7}>
            <Paper className={clsx(classes.paper, classes.detailsWidget)}>
              <CustomerDetails
                // buttons
                add1ButtonText={t('customerManager_addNewCustomer')}
                onDeleteButtonClick={this.openDeleteCustomerAlert}
                onAdd1ButtonClick={this.handleAddCustomer}
                onSaveButtonClick={this.handleSaveCustomer}
                // TODO delete next line and uncomment following line to enable delete
                isDeleteButtonDisabled={true}
                // isDeleteButtonDisabled={!this.state.customerId || this.state.isNewCustomer}
                //add2ButtonDisabled={this.state.isNewCustomer}
                saveButtonDisabled={!this.state.customerId && !this.state.isNewCustomer}
                // customer details form
                onKeyPressFormSubmit={this.handleCustomerDetailsFormKeyPress}
                bodyComponent="customerDetails"
                onChange={this.handleChangeFormValues}
                hideDetails={this.state.hideDetails}
                siteId={this.state.customerId}
                firstName={this.state.firstName}
                lastName={this.state.lastName}
                street1={this.state.street1}
                street1no={this.state.street1no}
                zip={this.state.zip}
                city={this.state.city}
                customerNumber={this.state.customerNumber}
                noHeader
                noFooter
              />
            </Paper>
          </Grid>
        </Grid>
      </MainContentContainer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    customerId: state.auth.customerId,
    distributorId: state.auth.distributorId,
    customers: state.customers.customersForAdmin,
    customersIsLoading: state.customers.isLoading,
    customerTotalElements: state.customers.totalElements,
    successMessage: state.customers.successMessage,
    errorMessage: state.customers.errorMessage,
    createdId: state.customers.createdId,
    createdAddressId: state.customers.createdAddressId,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getCustomersForAdmin: (distributorId, pageParams) =>
    dispatch(CustomersActions.getCustomersForAdminRequest(distributorId, pageParams)),
  deleteCustomer: (customerId, distributorId, pageParams) =>
    dispatch(CustomersActions.deleteCustomerRequest(customerId, distributorId, pageParams)),
  createCustomer: (customerInfos, distributorId, pageParams) =>
    dispatch(CustomersActions.createCustomerRequest(customerInfos, distributorId, pageParams)),
  editCustomer: (customerInfos, distributorId, pageParams) =>
    dispatch(CustomersActions.editCustomerRequest(customerInfos, distributorId, pageParams)),
});

export default compose(
  withTranslation(),
  withStyles(styles),
  withWidth(),
  connect(mapStateToProps, mapDispatchToProps)
)(Customers);
